var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudioCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5C0 10.742 0.195508 10.9375 0.4375 10.9375H10.5C10.742 10.9375 10.9375 10.742 10.9375 10.5V4.75781H0V10.5ZM10.5 0.984375H8.20312V0.109375C8.20312 0.0492187 8.15391 0 8.09375 0H7.32812C7.26797 0 7.21875 0.0492187 7.21875 0.109375V0.984375H3.71875V0.109375C3.71875 0.0492187 3.66953 0 3.60938 0H2.84375C2.78359 0 2.73438 0.0492187 2.73438 0.109375V0.984375H0.4375C0.195508 0.984375 0 1.17988 0 1.42188V3.82812H10.9375V1.42188C10.9375 1.17988 10.742 0.984375 10.5 0.984375Z",
    fill: "#9E4E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudioCalenderIcon);
export default __webpack_public_path__ + "static/media/studioCalenderIcon.da4f7a0615c8b4a6366564ae06299b51.svg";
export { ForwardRef as ReactComponent };